<template>
	<section class="py-8 md:py-24">
		<div class="w-full max-w-screen-xl mx-auto px-6">
			<div class="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
		        <div class="h-auto" :class="{
		        	'order-1': imagePosition === 'left',
		        	'order-1 md:order-2': imagePosition === 'right',
		        }">
		            <div class="h-full flex flex-col items-center justify-center">
		                <img :src="image" class="w-full h-auto" :alt="imageAlt" />
		            </div>
		        </div>
		        <div class="h-auto" :class="{
		        	'order-2': imagePosition === 'left',
		        	'order-2 md:order-1': imagePosition === 'right',
		        }">
		            <div class="h-full flex flex-col items-center justify-center">
		                <h2 class="text-2xl lg:text-3xl font-bold text-center">{{ title }}</h2>
		                <p class="mt-6 text-center whitespace-pre-line">{{ description }}</p>
		                <div class="text-xl font-bold mt-6 text-center">{{ price }}</div>
		                <CTA :href="$route('home::orders.create', { shape: shape })" variant="large" class="hidden md:flex mt-8">
		                    {{ ctaText }}
		                    <ChevronRightIcon class="h-4 w-4 ml-2" />
		                </CTA>
		            </div>
		        </div>
		    </div>
		</div>
	</section>
 </template>

 <script>
 	import {
        ChevronRightIcon,
    } from '@heroicons/vue/outline'

	export default {
		components: {
            ChevronRightIcon,
        },
		props: {
			shape: {
				type: [String, Number],
			},
			image: {
				type: String,
			},
			imageAlt: {
				type: String,
			},
			title: {
				type: String,
			},
			description: {
				type: String,
			},
			price: {
				type: String,
			},
			ctaText: {
				type: String,
			},
			imagePosition: {
				type: String,
				default: 'left',
			},
		}
	}
</script>
